import { type StyleProp, type ViewStyle } from "react-native";

import { isWeb } from "@stepapp/core";
import { palette, spacing } from "@stepapp/ui";

export const footerStyle: StyleProp<ViewStyle> = {
  backgroundColor: palette.common.white,
  borderTopColor: palette.font.placeholder,
  borderTopWidth: spacing.border,
  bottom: spacing.unit * (isWeb ? 2 : 0),
  elevation: 2,
  left: 0,
  paddingHorizontal: spacing.unit * 2,
  paddingTop: spacing.unit * 1,
  position: "absolute",
  right: 0,
  zIndex: 2,
  paddingBottom: spacing.unit * 2,
};
